"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _components = require("components");

var _DescriptionWith3Columns = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/DescriptionWith3Columns");

var _DescriptionWith3Columns2 = _interopRequireDefault(_DescriptionWith3Columns);

var _Hero = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Hero");

var _Hero2 = _interopRequireDefault(_Hero);

var _Home = require("../Home/Home");

var _QouteSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/QouteSection");

var _QouteSection2 = _interopRequireDefault(_QouteSection);

var _Feature = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/Feature");

var _Feature2 = _interopRequireDefault(_Feature);

var _Slider = require("@quixeltools/quixel-ui-library/dist/components/common/website/Slider");

var _Slider2 = _interopRequireDefault(_Slider);

var _VideoLinkSection = require("@quixeltools/quixel-ui-library/dist/components/common/marketing/VideoLinkSection");

var _VideoLinkSection2 = _interopRequireDefault(_VideoLinkSection);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _utils = require("utils");

var _cloudFront = require("../../utils/cloudFront");

var cf_utils = _interopRequireWildcard(_cloudFront);

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Megascans = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: state.auth.loggedIn
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Megascans, _React$Component);

  function Megascans(props) {
    (0, _classCallCheck3.default)(this, Megascans);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Megascans.__proto__ || (0, _getPrototypeOf2.default)(Megascans)).call(this, props));

    _this.state = {
      platform: "Windows"
    };
    _this.renderContactUsForm = _this.renderContactUsForm.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Megascans, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var platform = (0, _utils.detectOperatingSystem)();
      this.setState({ platform: platform });
    }
  }, {
    key: "renderContactUsForm",
    value: function renderContactUsForm(title, description, tag, initialValues) {
      this.context.dialogs.custom(_react2.default.createElement(_components.ContactUsPopupContainer, {
        title: title,
        description: description,
        tag: tag,
        initialValues: {
          name: _ramda2.default.propOr("", "name", initialValues),
          email: _ramda2.default.propOr("", "email", initialValues),
          subject: _ramda2.default.propOr("", "subject", initialValues),
          comment: _ramda2.default.propOr("", "comment", initialValues)
        }
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _components.AppSideEffects,
        {
          documentTitle: "- We capture the world so you can create your own",
          documentImage: cf_utils.cf_thumbs("page-thumb-megascans.jpg"),
          documentDescription: "Learn about our history in 3D scanning and developing software and exploring new ways of working for the entire industry."
        },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_Hero2.default, {
            Indie: true,
            bg: cf_utils.cf_qx_page("about", "about-hero.jpg"),
            superIconUrls: [cf_utils.cf_icons("quixel_logo.png")],
            primaryLabel: "",
            primaryTo: "",
            title: "we capture the world",
            subTitle: "So that you can create your own."
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "Company",
            img: cf_utils.cf_qx_page("about", "about-skull.jpg"),
            title: "about us",
            newHome: true,
            desc: "We make Megascans, Bridge and Mixer \u2014 a unique 3D asset library and two companion applications for 3D art creation. With these products, our community of users creates amazing 3D art for videogames, movies, architecture visualisation and more.",
            link: [{
              href: "https://youtu.be/Sh7Gbyf4XMY",
              label: "See our product video",
              newWindow: true
            }]
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "Company",
            img: cf_utils.cf_qx_page("about", "about-history.jpg"),
            title: "HISTORY",
            newHome: true,
            desc: "Quixel was founded in 2011 by Teddy Bergsman and Waqar Azim, based on the vision of substantially speeding up how creators build digital environments, by giving them access to a vast and ever-expanding library of 3D building blocks, and easy-to-use tools to greatly simplify the creative process.",
            flip: true,
            link: [{
              href: "/megascans/library/home",
              label: "explore megascans"
              // onClick:()=>(__CLIENT__ ? window.location=window.location.protocol+'//'+window.location.hostname+'/megascans/library/':'')
            }]
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "Company",
            img: cf_utils.cf_qx_page("about", "about-location-2.jpg"),
            title: "locations",
            newHome: true,
            desc: "Today we are more than 100 people in 6 different countries , with headquarters in Sweden and Pakistan. Many of us have a strong background in the games and VFX industries, and are still very active in the community.",
            link: [{
              label: "contact us",
              onClick: function onClick() {
                return _this2.renderContactUsForm("We are here to help!", "Leave us a note and we will get back to you soon.", "About Us");
              }
            }]
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "Company",
            img: cf_utils.cf_qx_page("about", "about-joinus.jpg"),
            title: "join us",
            newHome: true,
            flip: true,
            desc: "We\u2019re always on the lookout for amazing people to join our team. If you\u2019re a technically skilled artist, developer, or creative with a passion for changing how digital industries work today and in the future, chances are we\u2019d get along quite well. ",
            link: [{
              href: "/jobs",
              label: "go to jobs"
            }]
          }),
          _react2.default.createElement(_Feature2.default, {
            featureType: "Company",
            img: cf_utils.cf_qx_page("about", "about-contactus.jpg"),
            title: "get in touch",
            newHome: true,
            desc: "Want to send us some love? Some hate? Need support, or have a business proposal? Through our contact form you\u2019ll find the right way to get in touch with us, no matter what\u2019s on your mind.",
            link: [{
              label: "contact us",
              onClick: function onClick() {
                return _this2.renderContactUsForm("We are here to help!", "Leave us a note and we will get back to you soon.", "About Us");
              }
            }]
          })
        )
      );
    }
  }]);
  return Megascans;
}(_react2.default.Component), _class2.contextTypes = {
  router: _react2.default.PropTypes.object,
  dialogs: _react2.default.PropTypes.object
}, _temp)) || _class);
exports.default = Megascans;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/About/About.jsx
// module id = 2620
// module chunks = 0